import { Box, Spacer } from '@chakra-ui/react';
import { FC } from 'react';
import PeCompanyClientsSection from './sections/clients/PeCompanyClientsSection';
import PeCompanyCompetitorsTable from './sections/competitors/PeCompanyCompetitorsTable';
import PeCompanyEstimateFromAnalyticsSection from './sections/estimate/PeCompanyEstimateFromAnalyticsSection';
import PeCompanyFinanceHistoryTable from './sections/financeHistory/PeCompanyFinanceHistoryTable';
import PeAssetChartView from './sections/PeAssetChartView';
import PeCompanyDescriptionSection from './sections/PeCompanyDescriptionSection';
import PeCompanyMainDetailsSection from './sections/PeCompanyMainDetailsSection';
import PeCompanyReportSection from './sections/PeCompanyReportSection';
import PeCompanyRelatedP2POrdersSection from './sections/relatedOrders/PeCompanyRelatedP2POrdersSection';
import PeCompanyRelatedSharesproOrdersSection from './sections/relatedOrders/PeCompanyRelatedSharesproOrdersSection';

interface Props {
  company: PeCompanyDetail;
}

const PeCompanyInfo: FC<Props> = ({ company }) => {
  return (
    <>
      <PeCompanyMainDetailsSection company={company} />
      <Spacer h="20px" />
      {company.sharesproOrders.length > 0 && (
        <PeCompanyRelatedSharesproOrdersSection
          sharesproOrders={company.sharesproOrders}
        />
      )}
      {company.investorsOrders.length > 0 && (
        <PeCompanyRelatedP2POrdersSection p2pOrders={company.investorsOrders} />
      )}
      {company.report?.fileUrl && (
        <Box mb="20px">
          <PeCompanyReportSection report={company.report} />
        </Box>
      )}
      {company.description && (
        <Box mb="20px">
          <PeCompanyDescriptionSection description={company.description} />
        </Box>
      )}
      {company.estimateFromAnalytics && (
        <Box mb="20px">
          <PeCompanyEstimateFromAnalyticsSection
            data={company.estimateFromAnalytics}
          />
        </Box>
      )}
      {company.clients.length > 0 && (
        <Box mb="20px">
          <PeCompanyClientsSection clients={company.clients} />
        </Box>
      )}
      {company.investments.length > 0 && (
        <Box mb="20px">
          <PeCompanyFinanceHistoryTable investments={company.investments} />
        </Box>
      )}
      {company.investmentsChartData.length > 1 && (
        <Box mb="20px">
          <PeAssetChartView chartData={company.investmentsChartData} />
        </Box>
      )}
      {company.competitors.length > 0 && (
        <Box mb="20px">
          <PeCompanyCompetitorsTable competitors={company.competitors} />
        </Box>
      )}
    </>
  );
};

export default PeCompanyInfo;
